<div class="card">
  <!-- Header with filters -->
  <div class="card-header border-bottom">
    <div class="d-flex flex-column flex-lg-row gap-3">
      <!-- Search -->
      <div class="flex-grow-1">
        <div class="input-group">
          <span class="input-group-text bg-light border-end-0">
            <i class="fa-solid fa-search text-muted"></i>
          </span>
          <input type="text" class="form-control border-start-0 ps-0"
                 [(ngModel)]="searchQuery"
                 (keyup.enter)="onSearch()"
                 [placeholder]="'admin.users.searchPlaceholder' | translate">
          <app-button variant="primary" (clicked)="onSearch()" label="{{ 'common.search' | translate }}"></app-button>
        </div>
      </div>

      <!-- Filters -->
      <div class="d-flex gap-3 align-items-center">
        <div class="form-check mb-0">
          <input type="checkbox" class="form-check-input" id="activeOnly"
                 [(ngModel)]="activeOnly" (change)="onFilterChange()">
          <label class="form-check-label text-nowrap" for="activeOnly">{{ 'admin.users.activeOnly' | translate }}</label>
        </div>
        <div class="form-check mb-0">
          <input type="checkbox" class="form-check-input" id="trainersOnly"
                 [(ngModel)]="trainersOnly" (change)="onFilterChange()">
          <label class="form-check-label text-nowrap" for="trainersOnly">{{ 'admin.users.trainersOnly' | translate }}</label>
        </div>
        <div class="text-muted text-nowrap ms-2">
          <strong>{{ totalItems }}</strong> {{ 'admin.users.totalCount' | translate | lowercase }}
        </div>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="card-body p-0">
    @if (loading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (users.length === 0) {
      <div class="text-center py-5 text-muted">
        <i class="fa-solid fa-users fa-3x mb-3 opacity-50"></i>
        <p class="mb-0">{{ 'admin.users.noResults' | translate }}</p>
      </div>
    } @else {
      <!-- Table header -->
      <div class="table-header">
        <div class="th-name">{{ 'admin.users.name' | translate }}</div>
        <div class="th-email">{{ 'admin.users.email' | translate }}</div>
        <div class="th-phone">{{ 'admin.users.phone' | translate }}</div>
        <div class="th-created">{{ 'admin.users.created' | translate }}</div>
      </div>

      <!-- User list -->
      <div class="user-list">
        @for (user of users; track user.user_id) {
          <div class="user-item">
            <!-- Name -->
            <div class="user-item-main">
              <div class="user-avatar">
                @if (user.profile_image_url) {
                  <img [src]="user.profile_image_url" alt="" class="avatar-img">
                } @else {
                  <div class="avatar-placeholder">
                    {{ user.first_name?.charAt(0) }}{{ user.last_name?.charAt(0) }}
                  </div>
                }
              </div>
              <div class="user-info">
                <div class="user-name">
                  {{ user.full_name }}
                  @if (user.active === 1) {
                    <span class="badge bg-success-subtle text-success">{{ 'common.active' | translate }}</span>
                  } @else {
                    <span class="badge bg-danger-subtle text-danger">{{ 'common.inactive' | translate }}</span>
                  }
                </div>
                <div class="user-id">{{ user.user_id }}</div>
              </div>
            </div>

            <!-- Email -->
            <div class="user-email">
              <a [href]="'mailto:' + user.email">{{ user.email }}</a>
            </div>

            <!-- Phone -->
            <div class="user-phone">
              @if (user.phone) {
                <a [href]="'tel:' + user.phone">{{ user.phone }}</a>
              } @else {
                <span class="text-muted">-</span>
              }
            </div>

            <!-- Created -->
            <div class="user-created">
              {{ user.created_at | date:'dd.MM.yyyy' }}
            </div>
          </div>
        }
      </div>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="card-footer bg-light d-flex justify-content-between align-items-center">
          <span class="text-muted small">
            {{ 'admin.pagination.showing' | translate }} {{ (currentPage - 1) * perPage + 1 }}-{{ Math.min(currentPage * perPage, totalItems) }} {{ 'admin.pagination.of' | translate }} {{ totalItems }}
          </span>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="currentPage > 1 && onPageChange(currentPage - 1)">
                  <i class="fa-solid fa-chevron-left"></i>
                </a>
              </li>
              @for (page of getPages(); track page) {
                <li class="page-item" [class.active]="page === currentPage">
                  <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
                </li>
              }
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="currentPage < totalPages && onPageChange(currentPage + 1)">
                  <i class="fa-solid fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      }
    }
  </div>
</div>
